import React from 'react';
import AssetAlertPopover from '../../../Common/Layout/AssetAlertPopover/assetAlertPopover.js';
import Link from '../../../Common/Layout/Link/link.js';
import PropTypes from 'prop-types';

require('./entityAlertIdCell.scss');

export default class EntityAlertIdCell extends React.PureComponent {

  render() {
    let {value, className = ''} = this.props;

    if (value) {
      return (<div className="entity-alert-id-cell">
        <Link label={value.label} id={value.id} type={value.type} className={className} disabled={value.disabled}/>
        <AssetAlertPopover value={value}/>
      </div>);
    }
    return null;
  }
}

EntityAlertIdCell.propTypes = {
  value: PropTypes.object,
  className: PropTypes.string,
};







